import { Dropdown } from "antd";
import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { notificationError } from "utils/libHelpers/AntdNotification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { documentsTableStore } from "../../Stores/DocumentsTableStore";
import { modal } from "Components/General/Modal/AntdModal";

interface FolderRelationsSymlinkInfoActionsProps {
  data: API_FolderRelationsSymlinkInfo;
}

export const FolderRelationsSymlinkInfoActions = observer(({ data }: FolderRelationsSymlinkInfoActionsProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);

  const handleMenuClick = ({ key, domEvent }) => {
    domEvent.preventDefault();
    domEvent.stopPropagation();

    switch (key) {
      case "jumpto":
        window.open(
          `${window.location.origin}/${window.GLOBAL.API_BASE}/project/${data.targetProjectId}/documents/docs/${data.targetFolderId}`,
          "_blank"
        );
        break;
      case "delete_link":
        modal.confirm({
          title: t("Delete link"),
          content: t("Do you really want to delete the link?"),
          okText: t("Yes"),
          cancelText: t("No"),
          zIndex: 999999,
          onOk: () => documentsTableStore.deleteLinkInExternProject(data),
        });
        break;
      default:
        notificationError("Error", "Unknown action" + key);
        break;
    }
  };

  const menu = [
    {
      label: t("Jump to directory"),
      key: "jumpto",
      disabled: !data.actions.jumpToProject,
      icon: <FontAwesomeIcon icon={["far", "folder"]} fixedWidth={true} className="mr-5" />,
    },
    {
      label: t("Delete link"),
      key: "delete_link",
      disabled: !data.actions.deleteLink,
      icon: <FontAwesomeIcon icon={["far", "trash-alt"]} fixedWidth={true} className="mr-5" />,
    },
  ];

  return (
    <Dropdown menu={{ items: menu, onClick: handleMenuClick }} trigger={["click"]}>
      <div className="text-center pointer" style={{ width: 25 }} onClick={(e) => e.preventDefault()}>
        <FontAwesomeIcon icon={["far", "ellipsis-v"]} />
      </div>
    </Dropdown>
  );
});
